import {
    FETCH_CM_ENUMS
} from '../actions/cmenums';


export const initialState = {
    isFetching: true,
    data: null
};

export const cmEnums = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CM_ENUMS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CM_ENUMS}_SUCCESS`:

            var result = {};

            action.payload.data.forEach((item, index) => {
                var mappingResult = {};
                item["enums"].forEach((e, i) => {
                    mappingResult[e.enumName] = e;
                })
                result[item["enumType"]] = mappingResult;
            });

            return Object.assign({}, state, {
                isFetching: false,
                data: result,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/cmenums.js